import React, { useState } from 'react';

import Button from '@elements/Button';
import LogoDown from '@svg/icons/arrow-down.svg';

import './style.css';

type AccordionItemProps = {
  description: string,
  title: string,
  cta: string,
  ctaHref: string,
  ctaText: string,
  ctaColor: string,
}

const AccordionItem = ({
  title,
  description,
  cta,
  ctaHref,
  ctaText,
  ctaColor,
}: AccordionItemProps): JSX.Element => {
  const [collapse, setCollapse] = useState(true);
  
  return (
    <div
      className={
        `acordion-item ${
          collapse
          ? 'acordion-item--collapsed'
          : ''
        }`
      }
    >
      <div className="acordion-item__title">
        { title }
        <Button
          ariaLabel="icon-arrow"
          onClick={ ()=> setCollapse(!collapse) }
        >
          <LogoDown />
        </Button>
      </div>
      <div className="acordion-item__body">
        {description}
        {
          cta.toLowerCase() === "yes" ? 
            <div className="acordion-item__cta">
              <Button
                childClassName={`btn--${ctaColor}`}
                children={ctaText}
                href={ctaHref}
              >  
              </Button>
            </div> :
          null
        }
      </div>
    </div>
  );
};

export default AccordionItem;
